import React from 'react';
import {
  List,
  ListItemButton,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Typography,
  Box,
  Chip,
} from '@mui/material';
import { StatusChip } from './styles';
import { getStatusIcon, getAvatarBgColor, getResponseStatusIcon, getResponseStatusAvatarBgColor } from './statusUtils';
const formatLabel = (input) => {
  return input
    .replace(/_/g, " ")                       // Replace underscores with spaces
};

const getRoleBadgeColor = (role) => {
  if (!role) return 'default';
  const roleUpper = role.toUpperCase();
  if (roleUpper.includes('COORDINATOR')) return 'primary';
  if (roleUpper.includes('RD')) return 'secondary';
  return 'default';
};

const formatRoleLabel = (role) => {
  if (!role) return '';
  return role.replace(/_/g, ' ');
};

export const MemberList = ({ members, selectedMember, onSelect }) => {
  if (!members || members.length === 0) {
    return (
      <List sx={{ px: 0, mt: 0, pt: 0, pb: 0, dense: true }}>
        <ListItemButton disabled>
          <ListItemText
            primary={
              <Typography variant="body2" color="text.secondary">
                No members found
              </Typography>
            }
          />
        </ListItemButton>
      </List>
    );
  }

  return (
    <List sx={{ px: 0, mt:0, pt:0, pb:0, dense: true }}>
      {members.map((member) => {
      const status = member.hasResponded && member.response?.status ? member.response?.status : "PENDING";
      return (
        <ListItemButton
          key={member.id}
          selected={selectedMember?.id === member.id}
          onClick={() => onSelect(member)}
          sx={{
            borderLeft: '4px solid',
            borderLeftColor: selectedMember?.id === member.id
              ? 'primary.main'
              : 'transparent',
            bgcolor: selectedMember?.id === member.id
              ? 'rgba(0, 0, 0, 0.04)'
              : 'transparent',
            py: 0.5, // Reduced vertical padding
            minHeight: '50px' // Reduced minimum height
          }}
        >
          <ListItemAvatar sx={{ minWidth: '42px' }}>
            <Avatar
              sx={{
                bgcolor: getResponseStatusAvatarBgColor(status),
                width: 32,
                height: 32,
                fontSize: '0.9rem'
              }}
            >
              {getResponseStatusIcon(status)}
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <Typography
                    component="span"
                    fontWeight="medium"
                    sx={{ fontSize: '0.85rem', lineHeight: 1.2 }}
                  >
                    {member.username}
                  </Typography>
                  {member.role && (
                    <Chip
                      label={formatRoleLabel(member.role)}
                      size="small"
                      color={getRoleBadgeColor(member.role)}
                      sx={{ height: '16px', fontSize: '0.6rem', minWidth: '14px' }}
                    />
                  )}
                </Box>
              </Box>
            }
            secondary={
              <Box sx={{ mt: 0 }}>
                <Typography
                  component="span"
                  variant="body2"
                  display="block"
                  sx={{ fontSize: '0.75rem', lineHeight: 1.2, mb: 0.25 }}
                >
                  {member.category}
                </Typography>
                {member.region && (
                  <Typography
                    component="span"
                    variant="body2"
                    color="text.secondary"
                    sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}
                  >
                    {member.region}
                  </Typography>
                )}
              </Box>
            }
            sx={{ my: 0, py: 0 }} // Reduce margin and padding
          />
          <StatusChip
            status={status}
            label={member.hasResponded && member.response?.status ? formatLabel(member.response?.status) : "PENDING"}
            size="small"
            sx={{ height: '20px', fontSize: '0.65rem' }} // Reduce chip height and font size
          />
        </ListItemButton>
      );
    })}
  </List>
  );
};
